// @flow

export type paramsType = {
  slug: string,
  typeRugby?: string,
  category?: string,
}

export type SEOPageType = {
  slug: (params?: paramsType) => string,
  title: (str?: any, ...params: Array<any>) => string,
  description: (str?: any, ...params: Array<any>) => ?string
};

export const nullPage: SEOPageType = {
  slug: () => 'unknow-slug',
  title: () => '',
  description: () => null,
};
 
export const SEOPages: Array<SEOPageType> = [
  {
    slug: () => 'trouver-un-club-de-rugby',
    title: () => 'Trouver un club - Fédération Française de Rugby',
    description: () => 'Retrouvez les clubs les plus proches de chez vous, filtrés par pratique, nombre de licenciés, horaires, compétitions et apprenez en plus sur votre futur club', // eslint-disable-line max-len
  },

  {
    slug: () => 'trouver-un-club-de-rugby/resultats-de-recherche/',
    title: (search: string = '') => `Club de rugby aux alentours ${search !== '' ? 'de ' + search : ''} - 
Fédération Française de Rugby`.replace(/\n/g, ''),
    description: () => `Retrouvez les clubs les plus proches de chez vous, filtrés par pratique, nombre de licenciés, horaires, compétitions et apprenez en plus sur votre futur club`, // eslint-disable-line max-len
  },

  {
    slug: () => 'evenements',
    title: (ligue: string = '', month?: string, year?: string) =>
      `Evenement rugby ${ligue}${month && year ? ` - ${month} ${year}` : ''}`,
    description: (ligue: string = '', month?: string, year?: string) =>
      `Les évènements officiels de la ligue ${ligue} de Rugby${month && year ? ` - ${month} ${year}` : ''}.`
  },

  {
    slug: () => 'contact',
    title: () => 'Contact',
    description: () => `La ligue répond à vos questions. À quel sujet pouvons-nous vous aider ?`,
  },

  {
    slug: () => 'faq',
    title: (ligue: string = '') => `Foire aux question - Ligue ${ligue} de rugby`,
    description: () => `Retrouvez toutes les réponses à vos questions sur notre ligue de rugby 
et contactez-nous si vous celle-ci n'est pas présente dans notre liste.`.replace(/\n/g, ''), 
  },
 
  {
    slug: () => 'faq/slugtheme',
    title: (theme: string = '') => `Foire aux question - rubrique ${theme}`,
    description: (theme: string = '') => `Retrouvez toutes les réponses à vos questions sur notre ligue de rugby 
dans la thématique ${theme}`.replace("\n", ''),
  },

  {
    slug: () => 'social-wall',
    title: () => `Réseaux sociaux rugby`,
    description: (ligue: string = '') => `Réseaux sociaux de la ligue ${ligue} de Rugby.`,
  },

  {
    slug: () => 'recherche',
    title: (ligue: string = '') => `Recherche - Ligue ${ligue}`,
    description: () => null,
  },

  {
    slug: () => 'actualites',
    title: (ligue: string = '') => 'Dernières actualités rugby de la FFR - Fédération Française de Rugby',
    description: (ligue: string = '') => `Toute l'actualité rugby de la FFR : infos, dernières minutes, 
équipes de France, France 7, XV de France, Equipes féminines, arbitrage, règles du jeu, infos joueurs, 
compositions d'équipe… avec la Fédération Française de Rugby.`.replace(/\n/g, ''),
  },

  {
    slug: () => 'actualites/arbitrage',
    title: (ligue: string = '') => `Actualités arbitrage ligue rugby ${ligue}`,
    description: (ligue: string = '') => `Les actualités arbitrage de la ligue ${ligue} de Rugby.`,
  },

  {
    slug: () => 'actualites/clubs_et_comites',
    title: (ligue: string = '') => `Actualités clubs rugby ${ligue}`,
    description: (ligue: string = '') => `Les actualités officielles des clubs de la ligue ${ligue} de Rugby.`,
  },

  {
    slug: () => 'actualites/ecole_rugby',
    title: (ligue: string = '') => `Actualités écoles rugby ${ligue}`,
    description: (ligue: string = '') => `Les actualités officielles des écoles de la ligue ${ligue} de Rugby.`,
  },

  {
    slug: () => 'actualites/ligue',
    title: (ligue: string = '') => `Actualités de la ligue ${ligue}`,
    description: (ligue: string = '') => `Les actualités officielles de la ligue ${ligue}`,
  },

  {
    slug: () => 'actualites/non-classe',
    title: (ligue: string = '') => `Actualités de la ligue ${ligue} - rubrique non classée`,
    description: (ligue: string = '') => `Les actualités officielles de la ligue qui ne sont pas classés dans les autres catégories - ligue  ${ligue}`, // eslint-disable-line max-len
  },

  {
    slug: () => 'actualites/rugby-a-5',
    title: (ligue: string = '') => `Actualités rugby à cinq ligue ${ligue}`,
    description: (ligue: string = '') => `Les actualités officielles de la ligue ${ligue} de Rugby à cinq.`,
  },

  {
    slug: () => 'actualites/rugby-a-7',
    title: (ligue: string = '') => `Actualités rugby à sept ligue ${ligue}`,
    description: (ligue: string = '') => `Les actualités officielles de la ligue ${ligue} de Rugby à sept.`,
  },

  {
    slug: () => 'actualites/rugby-feminin',
    title: (ligue: string = '') => `Actualités rugby féminin ligue ${ligue}`,
    description: (ligue: string = '') => `Les actualités officielles de la ligue ${ligue} de Rugby féminin.`,
  },

  {
    slug: () => 'actualites/vers-le-haut-niveau',
    title: (ligue: string = '') => `Actualités rugby haut-niveau ligue ${ligue}`,
    description: (ligue: string = '') => `Les actualités officielles de la ligue ${ligue} du haut-niveau.`,
  },

  {
    slug: () => 'competitions',
    title: (ligue: string = '') => `Compétitions de la Ligue ${ligue}`,
    description: (ligue: string = '') => `Toutes les compétitions au sein de la ligue ${ligue}`,
  },

  {
    slug: () => 'ffr',
    title: (ligue: string = '') => 'Tout savoir sur la Fédération Française de Rugby - Fédération Française de Rugby',
    description: (ligue: string = '') => `Retrouvez toute les informations de la FFR sur le site de la 
Fédération Française de Rugby : publications officielles, annuaires, espaces presse, juridique…`.replace(/\n/g, ''),
  },
   
  {
    slug: (params: Object = {}) => `actualites/${params.category}`,
    title: (articleThematic: string = '') => `${articleThematic} - Fédération Française de Rugby`,
    description: (articleThematic: string = '') => `${articleThematic} - Toute l'actualité rugby de la FFR : 
infos, dernières minutes… avec la Fédération Française de Rugby.`.replace(/\n/g, '')
  },

  {
    slug: () => 's-engager',
    title: (meta_title: string = '') => meta_title,
    description: (ligue: string = '') => `S'engager et être acteur du monde du rugby : 
    Bénévoles, Entraineurs, Educateurs, Arbitres, dirigeants… avec la Fédération Française de Rugby.`,
  },

  {
    slug: (params: Object = {}) => `clubs/${params.slug}`,
    title: (clubName: string = '') => `Club de Rugby ${clubName} - Fédération Française de Rugby`,
    description: (clubName: string = '') => `${clubName} : fiche contact du club de rugby, pratiques proposées… 
    trouver un club près de chez vous avec la Fédération Française de Rugby.`
  },

  {
    slug: () => `equipe-de-france`,
    title: (meta_title: string = '') => meta_title,
    description: () => `Les équipes de France de rugby : découvrez les joueurs des équipes, les résultats, 
les prochaines compétitions, le staff, les dernières actualités, l'agenda… avec la Fédération Française de Rugby.`
.replace(/\n/g, '')
  },

  {
    slug: (params: Object = {}) => `equipe-de-france/${params.typeRugby}/${params.slug}`,
    title: (meta_title: string = '') => meta_title,
    description: (meta_title: string = '') => `${meta_title} : découvrez les joueurs de l'équipe, les résultats, 
les prochaines compétitions, le staff, les dernières actualités de l'équipe, l'agenda… 
avec la Fédération Française de Rugby.`.replace(/\n/g, '')
  },

  {
    slug: (params: Object = {}) => `equipe-de-france/${params.typeRugby}/${params.slug}/actualites`,
    title: (meta_title: string = '') => `${meta_title} : Actualités - Fédération Française de Rugby`,
    description: (meta_title: string = '') => `${meta_title} : découvrez les joueurs de l'équipe, les résultats, 
les prochaines compétitions, le staff, les dernières actualités de l'équipe, l'agenda… 
avec la Fédération Française de Rugby.`.replace(/\n/g, '')
  },

  {
    slug: (params: Object = {}) => `equipe-de-france/${params.typeRugby}/${params.slug}/joueurs/${params.joueur}`,
    title: (joueur: string = '') => `${joueur} - Fédération Française de Rugby`,
    description: (joueur: string = '') => `${joueur} : Découvrez ses statistiques, son poste, sa biographie et 
ses derniers matchs joués avec la Fédération Française de Rugby.`.replace(/\n/g, '')
  },

  {
    slug: (params: Object = {}) => `equipe-de-france/${params.typeRugby}/${params.slug}/staff/${params.staff}`,
    title: (staff: string = '') => `${staff} - Fédération Française de Rugby`,
    description: (staff: string = '') => `${staff} : Découvrez son poste, sa biographie et 
ses derniers matchs avec la Fédération Française de Rugby.`.replace(/\n/g, '')
  },

  {
    slug: (params: Object = {}) => `equipe-de-france/${params.typeRugby}/${params.slug}/resultats`,
    title: (meta_title: string = '') => `${meta_title} : Résultats - Fédération Française de Rugby`,
    description: (meta_title: string = '') => `${meta_title} : découvrez les résultats des dernières compétitions 
de votre équipe préférée avec la Fédération Française de Rugby.`.replace(/\n/g, '')
  },

  {
    slug: (params: Object = {}) => `equipe-de-france/${params.typeRugby}/${params.slug}/agenda`,
    title: (meta_title: string = '') => `${meta_title} : Agenda - Fédération Française de Rugby`,
    description: (meta_title: string = '') => `${meta_title} : retrouvez l'agenda de votre équipe préférée 
avec la Fédération Française de Rugby.`.replace(/\n/g, '')
  },

  {
    slug: (params: Object = {}) => `equipe-de-france/${params.typeRugby}/${params.slug}/competitions`,
    title: (meta_title: string = '') => `${meta_title} : Compétitions`,
    description: (meta_title: string = '') => `${meta_title} : découvrez les compétitions en cours et les 
compétitions terminées de votre équipe préférée avec la Fédération Française de Rugby.`.replace(/\n/g, '')
  },

  {
    slug: (params: Object = {}) => `equipe-de-france/${params.typeRugby}/${params.slug}/joueurs`,
    title: (meta_title: string = '') => `${meta_title} : L'équipe - Fédération Françaisee de Rugby.`,
    description: (meta_title: string = '') => `${meta_title} : découvrez la composition d'équipe 
de votre équipe préférée avec la Fédération Française de Rugby. Statistiques des joueurs, biographie, poste…`
.replace(/\n/g, '')
  },
  
  {
    slug: (params: Object = {}) => `equipe-de-france/${params.typeRugby}/${params.slug}/staff`,
    title: (meta_title: string = '') => `${meta_title} : Staff - Fédération Française de Rugby.`,
    description: (meta_title: string = '') => `${meta_title} : découvrez le STAFF de votre équipe préférée 
avec la Fédération Française de Rugby. 
Entraineurs, consultants, médecins, préparateurs physique, analystes vidéo, Kinésithérapeuthe, manager…`
.replace(/\n/g, '')
  },
  {
    slug: (params: Object = {}) => `auteurs/${params.slug}`,
    title: (nom: string = '') => `Articles de ${nom} publiés sur ffr.fr`,
    description: (data: Object = {}) => `Articles et biographie de ${data.title}, ${data.role_edition} au sein de 
l’équipe de rédaction de la Fédération Francaise de Rugby.`.replace(/\n/g, '')
  },
  {
    slug: () => `histoires-de-rugby`,
    title: (meta_title: string = '') => meta_title,
    description: (meta_description: string = '') => meta_description.replace(/\n/g, '')
  },
];
